import React from "react";

import { House, PeopleAlt, PieChart, Place } from "@mui/icons-material";
import {
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import { AudienceSummary } from "@/types";
import { abbreviateNumber } from "@/utils";

interface AudienceSizeProps {
  data: AudienceSummary[];
}

const AudienceSegmentsSize: React.FC<AudienceSizeProps> = ({ data }) => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    borderBottomColor: theme.palette.divider,
  }));

  return (
    <TableContainer component={Paper} sx={{ maxWidth: 600 }}>
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="flex-start"
              >
                <PieChart fontSize="small" color="secondary" />
                <Typography variant="body2">Segment</Typography>
              </Stack>
            </StyledTableCell>
            <StyledTableCell align="right">
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="flex-end"
              >
                <Place fontSize="small" color="secondary" />
                <Typography variant="body2">
                  {data[0].num_postcodes ? "Postcodes" : "Sectors"}
                </Typography>
              </Stack>
            </StyledTableCell>
            <StyledTableCell align="right">
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="flex-end"
              >
                <House fontSize="small" color="secondary" />
                <Typography variant="body2">Households</Typography>
              </Stack>
            </StyledTableCell>
            <StyledTableCell align="right">
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="flex-end"
              >
                <PeopleAlt fontSize="small" color="secondary" />
                <Typography variant="body2">Audience Size</Typography>
              </Stack>
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((segment, index) => (
            <TableRow
              key={`audience-summary-${index}`}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <StyledTableCell>
                {segment.segment ?? `Segment ${index + 1}`}
              </StyledTableCell>
              {segment.num_postcodes && (
                <StyledTableCell align="right">
                  {abbreviateNumber(segment.num_postcodes)}
                </StyledTableCell>
              )}
              {segment.num_sectors && (
                <StyledTableCell align="right">
                  {abbreviateNumber(segment.num_sectors)}
                </StyledTableCell>
              )}
              <StyledTableCell align="right">
                {abbreviateNumber(segment.num_households)}
              </StyledTableCell>
              <StyledTableCell align="right">
                {abbreviateNumber(segment.population_count)}
              </StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AudienceSegmentsSize;
